/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_NInputs */

const en_tut_wakil_n = /** @type {(inputs: Tut_Wakil_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The guardrails are deliberately tight: it acts only when your status is not online, only in the scopes you ticked, at most once per thread per ten minutes, and never past your daily limit. It has read-only rights — it never changes an issue's status, never approves anything, and never answers another agent.`)
};

const id_tut_wakil_n = /** @type {(inputs: Tut_Wakil_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagarnya sengaja rapat: ia hanya bertindak kalau status Anda bukan online, hanya pada cakupan yang Anda centang, paling banyak sekali per thread dalam sepuluh menit, dan tidak melewati batas harian Anda. Ia berhak membaca saja — ia tidak pernah mengubah status issue, tidak menyetujui apa pun, dan tidak menjawab agen lain.`)
};

/**
* | output |
* | --- |
* | "The guardrails are deliberately tight: it acts only when your status is not online, only in the scopes you ticked, at most once per thread per ten minutes, a..." |
*
* @param {Tut_Wakil_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_n = /** @type {((inputs?: Tut_Wakil_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_n(inputs)
	return en_tut_wakil_n(inputs)
});